import {
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuSeparator,
} from '@ui/components/PopoverMenu/PopoverMenu';

import { UserSettingsProps } from '@features/user/hooks/useUserSettings';
import { UserMiniCard } from '@features/user/ui/UserMiniCard/UserMiniCard';

import { SiteSettingsMenuItems } from '../SiteSettingsItems/SiteSettingsMenuItems';

type Props = {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  editProfileLink?: string;
  user: {
    firstName: string;
    lastName: string;
  };
  settings?: UserSettingsProps;
  onLogout: () => void;
};

export function UserAuthMenuPopover({
  className,
  editProfileLink,
  user,
  isOpen,
  settings,
  onClose,
  onLogout,
}: Props) {
  return (
    <PopoverMenu className={className} isOpen={isOpen} onClose={onClose}>
      <PopoverMenuItem>
        <UserMiniCard user={user} />
      </PopoverMenuItem>

      <PopoverMenuItem href="/profile/">Личный кабинет</PopoverMenuItem>
      {editProfileLink && <PopoverMenuItem href={editProfileLink}>Мои данные</PopoverMenuItem>}
      {settings && <PopoverMenuSeparator />}
      {settings && <SiteSettingsMenuItems {...settings} />}
      <PopoverMenuSeparator />
      <PopoverMenuItem onClick={onLogout}>Выйти</PopoverMenuItem>
    </PopoverMenu>
  );
}
